


// // import React, { useState, useEffect } from 'react';
// // import { useParams, useNavigate } from 'react-router-dom';
// // import {
// //   Container,
// //   Box,
// //   Typography,
// //   Alert,
// //   CircularProgress,
// //   Button,
// // } from '@mui/material';
// // import { ArrowBack } from '@mui/icons-material';
// // import CreateBusiness from '../components/admin/CreateBusiness';
// // import { adminService } from '../services/admin';

// // const CreateBusinessPage = () => {
// //   console.log('🔴 CreateBusinessPage rendered');
// //   const { tenantId } = useParams();
// //   const navigate = useNavigate();
// //   const [business, setBusiness] = useState(null);
// //   const [loading, setLoading] = useState(false);
// //   const [error, setError] = useState(null);

// //   const isEditMode = Boolean(tenantId);

// //   useEffect(() => {
// //     if (isEditMode) fetchBusiness();
// //   }, [tenantId]);

// //   const fetchBusiness = async () => {
// //     try {
// //       setLoading(true);
// //       const data = await adminService.getBusiness(tenantId);
// //       setBusiness(data);
// //     } catch {
// //       setError('Failed to load business details');
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   return (
// //     <Container maxWidth="lg">
// //       <Box sx={{ py: 0 }}>
// //         <Button
// //           startIcon={<ArrowBack />}
// //           onClick={() => navigate('/admin/businesses')}
// //           sx={{ mr: 2 }}
// //         >
// //           Back
// //         </Button>
// // {/* 
// //         <Typography variant="h5" sx={{ mb: 2 }}>
// //           {isEditMode ? 'Edit Business' : 'Create Business'}
// //         </Typography> */}

// //         {error && <Alert severity="error">{error}</Alert>}

// //         {loading && isEditMode ? (
// //           <Box sx={{ display: 'flex', justifyContent: 'center', mt: 9 }}>
// //             <CircularProgress />
// //           </Box>
// //         ) : (
// //           <CreateBusiness
// //             business={business}
// //             isEditMode={isEditMode}
// //             onSuccess={() => navigate('/admin/businesses')}
// //           />
// //         )}
// //       </Box>
// //     </Container>
// //   );
// // };

// // export default CreateBusinessPage;


// import React, { useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useFormik } from 'formik';
// import * as Yup from 'yup';
// import {
//   Container,
//   Box,
//   Typography,
//   Button,
//   TextField,
//   Select,
//   MenuItem,
//   FormControl,
//   Switch,
//   IconButton,
//   Alert,
//   CircularProgress,
//   Paper,
//   Grid,
//   Divider,
//   Breadcrumbs,
//   Link as MuiLink,
//   Chip,
//   FormHelperText,
//   Snackbar,
// } from '@mui/material';
// import {
//   ArrowBack as ArrowBackIcon,
//   CheckCircle,
//   Business as BusinessIcon,
//   InfoOutlined,
//   Close as CloseIcon,
// } from '@mui/icons-material';
// import { adminService } from '../services/admin';
// import { BUSINESS_STATUS } from '../utils/constants';

// /* ----------------------------------------------------------------------
//    Design tokens — kept consistent with CreateApplicationPage
// ---------------------------------------------------------------------- */
// const C = {
//   border: '#e2e8f0',
//   blue: '#3182ce',
//   blueDark: '#2b6cb0',
//   green: '#38a169',
//   greenDark: '#276749',
//   indigo: '#4c51bf',
//   textPrimary: '#1a202c',
//   textSecondary: '#718096',
//   bgLight: '#f7fafc',
//   badgeActiveBg: '#c6f6d5',
//   badgeActiveText: '#276749',
//   badgeInactiveBg: '#e2e8f0',
//   badgeInactiveText: '#4a5568',
//   infoBg: '#ebf8ff',
//   infoBorder: '#bee3f8',
//   infoText: '#2c5282',
// };

// const INDUSTRIES = [
//   'Technology', 'Finance', 'Healthcare', 'Retail', 'Education',
//   'Manufacturing', 'Real Estate', 'Hospitality', 'Transportation', 'Other',
// ];

// /* ----------------------------------------------------------------------
//    Validation schema
// ---------------------------------------------------------------------- */
// const validationSchema = Yup.object({
//   businessName: Yup.string()
//     .required('Business Name is required')
//     .min(2, 'Business Name must be at least 2 characters')
//     .max(100),
//   industry: Yup.string().required('Industry is required'),
//   contactEmail: Yup.string().email('Invalid email').required('Contact Email is required'),
//   emergencyContactNo: Yup.string()
//     .matches(/^[0-9]+$/, 'Only digits allowed')
//     .min(7, 'Min 7 digits')
//     .max(15, 'Max 15 digits')
//     .required('Emergency Contact is required'),
//   websiteUrl: Yup.string().url('Enter a valid URL').required('Website URL is required'),
//   webhookUrl: Yup.string().required('Webhook URL is required'),
//   accountStatus: Yup.string().required('Account Status is required'),
// });

// /* ----------------------------------------------------------------------
//    Inline field helper — label on the left, control on the right
//    (matches the pattern used in CreateApplicationPage)
// ---------------------------------------------------------------------- */
// const InlineField = ({ label, children, ...boxProps }) => (
//   <Box
//     sx={{
//       display: 'flex',
//       alignItems: 'flex-start',
//       gap: 2,
//       mb: 2.5,
//       ...boxProps.sx,
//     }}
//     {...boxProps}
//   >
//     <Typography
//       variant="body1"
//       fontWeight={600}
//       sx={{
//         minWidth: 180,
//         flexShrink: 0,
//         pt: 1,
//         fontSize: 15,
//         color: C.textPrimary,
//         letterSpacing: 0.1,
//       }}
//     >
//       {label}
//     </Typography>
//     <Box
//       sx={{
//         flex: 1,
//         '& .MuiInputBase-input': { fontSize: 14.5 },
//         '& .MuiInputBase-root': { fontSize: 14.5 },
//         '& .MuiFormHelperText-root': { fontSize: 12.5, mx: 0, mt: 0.5 },
//         '& .MuiSelect-select': { fontSize: 14.5 },
//       }}
//     >
//       {children}
//     </Box>
//   </Box>
// );

// const StatusBadge = ({ active, label }) => (
//   <Chip
//     label={label}
//     size="small"
//     sx={{
//       fontWeight: 700,
//       fontSize: 11,
//       height: 22,
//       bgcolor: active ? C.badgeActiveBg : C.badgeInactiveBg,
//       color: active ? C.badgeActiveText : C.badgeInactiveText,
//     }}
//   />
// );

// /* ----------------------------------------------------------------------
//    Main Component
// ---------------------------------------------------------------------- */
// const CreateBusiness = ({ business, isEditMode = false, onSuccess }) => {
//   const navigate = useNavigate();
//   const [loading, setLoading] = React.useState(false);
//   const [snackbar, setSnackbar] = React.useState({ open: false, message: '', severity: 'error' });

//   const showSnackbar = (message, severity = 'error') =>
//     setSnackbar({ open: true, message, severity });

//   const formik = useFormik({
//     initialValues: {
//       businessName: '',
//       industry: '',
//       contactEmail: '',
//       emergencyContactNo: '',
//       websiteUrl: '',
//       webhookUrl: '',
//       accountStatus: BUSINESS_STATUS.ACTIVE,
//     },
//     validationSchema,
//     onSubmit: async (values) => {
//       try {
//         setLoading(true);
//         if (isEditMode) {
//           await adminService.updateBusiness(business._id, values);
//           showSnackbar('Business updated!', 'success');
//         } else {
//           await adminService.createBusiness(values);
//           showSnackbar('Business created!', 'success');
//         }
//         setTimeout(() => onSuccess?.(), 1000);
//       } catch (err) {
//         showSnackbar(err.message || 'Something went wrong');
//       } finally {
//         setLoading(false);
//       }
//     },
//   });

//   const { values, handleChange, handleBlur, setFieldValue, errors, touched } = formik;

//   useEffect(() => {
//     if (!isEditMode || !business) return;
//     formik.setValues({
//       businessName: business.businessName || '',
//       industry: business.industry || '',
//       contactEmail: business.contactEmail || '',
//       emergencyContactNo: business.emergencyContactNo || '',
//       websiteUrl: business.websiteUrl || '',
//       webhookUrl: business.webhookUrl || '',
//       accountStatus: business.accountStatus || BUSINESS_STATUS.ACTIVE,
//     });
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [isEditMode, business?._id]);

//   const isActive = values.accountStatus === BUSINESS_STATUS.ACTIVE;

//   return (
//     <Container maxWidth={false} sx={{ py: 3, px: { xs: 2, sm: 3, md: 5 } }}>
//       {/* HEADER */}
//       <Box sx={{ mb: 3 }}>
//         <Breadcrumbs sx={{ mb: 0.5, fontSize: 13 }}>
//           <MuiLink
//             underline="hover"
//             color="text.secondary"
//             href="#"
//             onClick={(e) => {
//               e.preventDefault();
//               navigate('/admin/businesses');
//             }}
//           >
//             Businesses
//           </MuiLink>
//           <Typography color="text.primary" fontSize={13} fontWeight={600}>
//             {isEditMode ? 'Edit Business' : 'Create Business'}
//           </Typography>
//         </Breadcrumbs>

//         <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1.5, flexWrap: 'wrap' }}>
//           <Typography variant="h5" fontWeight={800} sx={{ color: C.textPrimary }}>
//             {isEditMode ? 'Edit Business' : 'Create New Business'}
//           </Typography>
//           <Typography variant="body2" color="text.secondary">
//             {isEditMode ? 'Update business information' : 'Add a new business account'}
//           </Typography>
//         </Box>
//       </Box>

//       {/* MAIN LAYOUT */}
//       <Box
//         sx={{
//           display: 'flex',
//           flexDirection: { xs: 'column', md: 'row' },
//           alignItems: 'flex-start',
//           gap: 3,
//         }}
//       >
//         {/* LEFT — form */}
//         <Box sx={{ flex: '1 1 0%', minWidth: 0, width: '100%' }}>
//           <Paper elevation={0} sx={{ borderRadius: 3, border: `1px solid ${C.border}`, p: 4 }}>
//             <Typography variant="h6" fontWeight={700} gutterBottom>
//               Business Details
//             </Typography>
//             <Typography variant="body2" color="text.secondary" sx={{ mb: 3.5 }}>
//               Provide basic information about the business
//             </Typography>

//             <form onSubmit={formik.handleSubmit}>
//               <InlineField label="Business Name *">
//                 <TextField
//                   fullWidth
//                   size="medium"
//                   name="businessName"
//                   placeholder="Enter business name"
//                   value={values.businessName}
//                   onChange={handleChange}
//                   onBlur={handleBlur}
//                   error={touched.businessName && Boolean(errors.businessName)}
//                   helperText={touched.businessName && errors.businessName}
//                 />
//               </InlineField>

//               <InlineField label="Industry *">
//                 <FormControl fullWidth size="medium" error={touched.industry && Boolean(errors.industry)}>
//                   <Select
//                     name="industry"
//                     displayEmpty
//                     value={values.industry}
//                     onChange={handleChange}
//                     onBlur={handleBlur}
//                   >
//                     <MenuItem value="" disabled>
//                       Select industry
//                     </MenuItem>
//                     {INDUSTRIES.map((i) => (
//                       <MenuItem key={i} value={i}>
//                         {i}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                   {touched.industry && errors.industry && (
//                     <FormHelperText error>{errors.industry}</FormHelperText>
//                   )}
//                 </FormControl>
//               </InlineField>

//               <InlineField label="Contact Email *">
//                 <TextField
//                   fullWidth
//                   size="medium"
//                   type="email"
//                   name="contactEmail"
//                   placeholder="business@example.com"
//                   value={values.contactEmail}
//                   onChange={handleChange}
//                   onBlur={handleBlur}
//                   error={touched.contactEmail && Boolean(errors.contactEmail)}
//                   helperText={touched.contactEmail && errors.contactEmail}
//                 />
//               </InlineField>

//               <InlineField label="Emergency Contact *">
//                 <TextField
//                   fullWidth
//                   size="medium"
//                   name="emergencyContactNo"
//                   placeholder="Digits only, e.g. 9198765432"
//                   value={values.emergencyContactNo}
//                   onChange={handleChange}
//                   onBlur={handleBlur}
//                   error={touched.emergencyContactNo && Boolean(errors.emergencyContactNo)}
//                   helperText={touched.emergencyContactNo && errors.emergencyContactNo}
//                 />
//               </InlineField>

//               <InlineField label="Website URL *">
//                 <TextField
//                   fullWidth
//                   size="medium"
//                   type="url"
//                   name="websiteUrl"
//                   placeholder="https://example.com"
//                   value={values.websiteUrl}
//                   onChange={handleChange}
//                   onBlur={handleBlur}
//                   error={touched.websiteUrl && Boolean(errors.websiteUrl)}
//                   helperText={touched.websiteUrl && errors.websiteUrl}
//                 />
//               </InlineField>

//               <InlineField label="Webhook URL *">
//                 <TextField
//                   fullWidth
//                   size="medium"
//                   name="webhookUrl"
//                   placeholder="https://example.com/webhook"
//                   value={values.webhookUrl}
//                   onChange={handleChange}
//                   onBlur={handleBlur}
//                   error={touched.webhookUrl && Boolean(errors.webhookUrl)}
//                   helperText={touched.webhookUrl && errors.webhookUrl}
//                 />
//               </InlineField>

//               <Divider sx={{ my: 2.5 }} />

//               <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 2 }}>
//                 Access & Status
//               </Typography>

//               <InlineField label="Account Status *">
//                 <FormControl fullWidth size="medium" error={touched.accountStatus && Boolean(errors.accountStatus)}>
//                   <Select name="accountStatus" value={values.accountStatus} onChange={handleChange}>
//                     {Object.values(BUSINESS_STATUS).map((s) => (
//                       <MenuItem key={s} value={s}>
//                         {s}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                   {touched.accountStatus && errors.accountStatus && (
//                     <FormHelperText error>{errors.accountStatus}</FormHelperText>
//                   )}
//                 </FormControl>
//               </InlineField>

//               <InlineField label="Enable Business">
//                 <Switch
//                   checked={isActive}
//                   onChange={(e) =>
//                     setFieldValue(
//                       'accountStatus',
//                       e.target.checked ? BUSINESS_STATUS.ACTIVE : BUSINESS_STATUS.INACTIVE
//                     )
//                   }
//                   color="primary"
//                 />
//                 <Typography variant="body2" color="text.secondary" sx={{ ml: 1, display: 'inline' }}>
//                   {isActive ? 'Business will be active' : 'Business will be inactive'}
//                 </Typography>
//               </InlineField>
//             </form>

//             {/* FOOTER ACTIONS */}
//             <Box
//               sx={{
//                 display: 'flex',
//                 justifyContent: 'space-between',
//                 alignItems: 'center',
//                 mt: 4,
//                 pt: 3,
//                 borderTop: `1px solid ${C.border}`,
//               }}
//             >
//               <Button
//                 variant="outlined"
//                 startIcon={<ArrowBackIcon />}
//                 onClick={() => navigate('/admin/businesses')}
//                 disabled={loading}
//                 sx={{ borderColor: C.border, color: C.textPrimary, px: 3, py: 1 }}
//               >
//                 Cancel
//               </Button>
//               <Button
//                 variant="contained"
//                 onClick={formik.handleSubmit}
//                 disabled={loading}
//                 endIcon={loading ? <CircularProgress size={20} color="inherit" /> : <CheckCircle />}
//                 sx={{
//                   background: `#2563EB`,
//                   color: '#fff',
//                   px: 5,
//                   py: 1.5,
//                 }}
//               >
//                 {loading ? 'Processing…' : isEditMode ? 'Update Business' : 'Create Business'}
//               </Button>
//             </Box>
//           </Paper>
//         </Box>

//         {/* RIGHT — preview sidebar */}
//         <Box
//           sx={{
//             flex: '0 0 auto',
//             width: { xs: '100%', md: 520 },
//             position: { md: 'sticky' },
//             top: { md: 16 },
//           }}
//         >
//           <Paper elevation={0} sx={{ borderRadius: 3, border: `1px solid ${C.border}`, p: 4 }}>
//             <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 2.5, fontSize: 17 }}>
//               Business Preview
//             </Typography>

//             <Box
//               sx={{
//                 border: `1px solid ${C.border}`,
//                 borderRadius: 2,
//                 p: 3,
//                 textAlign: 'center',
//                 mb: 2.5,
//               }}
//             >
//               <Box
//                 sx={{
//                   width: 88,
//                   height: 88,
//                   borderRadius: '50%',
//                   bgcolor: C.indigo,
//                   color: '#fff',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   fontSize: 28,
//                   fontWeight: 700,
//                   mx: 'auto',
//                   mb: 1.5,
//                 }}
//               >
//                 {values.businessName ? (
//                   values.businessName.slice(0, 2).toUpperCase()
//                 ) : (
//                   <BusinessIcon sx={{ fontSize: 34 }} />
//                 )}
//               </Box>
//               <Typography variant="h6" fontWeight={700}>
//                 {values.businessName || 'Business Name'}
//               </Typography>
//               {values.industry && (
//                 <Chip
//                   label={values.industry}
//                   size="small"
//                   sx={{ bgcolor: C.badgeActiveBg, color: C.badgeActiveText, fontWeight: 600, my: 1 }}
//                 />
//               )}
//               <Typography variant="body2" color="text.secondary">
//                 {values.contactEmail || 'business@example.com'}
//               </Typography>
//             </Box>

//             <Typography variant="subtitle2" fontWeight={700} color={C.blue} sx={{ mb: 1.5 }}>
//               Overview
//             </Typography>
//             <Box sx={{ border: `1px solid ${C.border}`, borderRadius: 2, p: 2 }}>
//               {[
//                 ['Website', values.websiteUrl || '-'],
//                 ['Webhook', values.webhookUrl || '-'],
//                 ['Emergency Contact', values.emergencyContactNo || '-'],
//               ].map(([label, value]) => (
//                 <Box key={label} sx={{ display: 'flex', justifyContent: 'space-between', py: 0.6, gap: 2 }}>
//                   <Typography variant="body2" color="text.secondary">
//                     {label}
//                   </Typography>
//                   <Typography
//                     variant="body2"
//                     fontWeight={600}
//                     sx={{ textAlign: 'right', wordBreak: 'break-all' }}
//                   >
//                     {value}
//                   </Typography>
//                 </Box>
//               ))}
//               <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.6 }}>
//                 <Typography variant="body2" color="text.secondary">
//                   Status
//                 </Typography>
//                 <StatusBadge active={isActive} label={isActive ? 'ACTIVE' : 'INACTIVE'} />
//               </Box>
//             </Box>

//             <Box
//               sx={{
//                 mt: 2.5,
//                 bgcolor: C.infoBg,
//                 border: `1px solid ${C.infoBorder}`,
//                 borderRadius: 2,
//                 p: 2,
//                 display: 'flex',
//                 gap: 1.5,
//               }}
//             >
//               <InfoOutlined sx={{ color: C.infoText, fontSize: 20, mt: 0.2 }} />
//               <Box>
//                 <Typography variant="body2" fontWeight={700} sx={{ color: C.infoText }}>
//                   Good to know
//                 </Typography>
//                 <Typography variant="caption" sx={{ color: C.infoText }}>
//                   Domains and white-label branding are configured separately, from the business's
//                   detail page, after the business has been created.
//                 </Typography>
//               </Box>
//             </Box>
//           </Paper>
//         </Box>
//       </Box>

//       {/* SNACKBAR */}
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={3000}
//         onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
//         anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
//       >
//         <Alert
//           severity={snackbar.severity}
//           variant="filled"
//           onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
//           action={
//             <IconButton size="small" color="inherit" onClick={() => setSnackbar((s) => ({ ...s, open: false }))}>
//               <CloseIcon fontSize="small" />
//             </IconButton>
//           }
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Container>
//   );
// };

// export default CreateBusiness;

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import CreateBusiness from '../components/admin/CreateBusiness';

const CreateBusinessPage = () => {
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate('/admin/businesses');
  };

  return (
    <Box>
      <CreateBusiness
        isEditMode={false}
        onSuccess={handleSuccess}
      />
    </Box>
  );
};

export default CreateBusinessPage;